import { IWcwOffer, IPayloadAddWcwCartItems } from '~/purchase/types';

export const prepareAddWcwCartPayload = (
  product: IWcwOffer,
): IPayloadAddWcwCartItems => ({
  items: product.offers
    .map(({ supplier, offerMetadata }) => ({
      wheel: { reference: product.wheel.reference, name: product.wheel.name },
      tyre: {
        ean: product.tyre.ean,
        brand: product.tyre.brand.name,
        profile: product.tyre.profile.design1,
        cai: product.tyre.supplierCode,
        constructorReference: product.tyre.constructorReference,
        alternativeReference: product.tyre.alternativeReference,
        season: product.tyre.season.name,
        vehicleType: product.tyre.vehicleType.name,
        vehicleTypePublicKey: product.tyre.vehicleType.publicKey,
        dimension: product.tyre.dimension.fullSize,
        productTypePublicKey: product.tyre.productType.publicKey,
      },
      supplier: {
        id: String(supplier.id),
        name: supplier.name,
        type: supplier.supplierBehavior,
        orderable: supplier.orderable ?? false,
      },
      quantity: product.wheel.salesUnit,
      price: {
        unitPrice: offerMetadata.priceExclTax,
        currency: offerMetadata.currency,
        recommendedPrice: offerMetadata.recommendedPrice,
      },
      deliveryDate: offerMetadata.deliveryDate,
      backOrder: offerMetadata.isBackOrder,
    }))
    .filter((item) => item.quantity !== 0),
});
